import type {SafeHTMLString} from '@github-ui/safe-html'
import {useQuery} from '@github-ui/react-query'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import type {SharedThreadPreview} from './thread-previews'

export type PendingCommentPreview = SharedThreadPreview & {
  bodyHTML: SafeHTMLString
}

export type PendingReview = {
  // id is undefined when there is no pending review for the viewer
  id?: string
  comments: PendingCommentPreview[]
}

export type PendingReviewIDs = PendingReview & {
  /**
   * pendingReviewIDs represents the IDs of threads that have pending comments.
   */
  pendingReviewIDs?: number[]
}

export function pendingReviewQueryKey(pathName: string) {
  return [PageData.pendingReview, pathName]
}

function pendingReviewPayload(pathName: string) {
  const queryKey = pendingReviewQueryKey(pathName)
  return {
    queryKey,
    queryFn: async () => {
      // Throwing an error prevents this function from overriding initialData
      throw new Error('This query function should not be executed')
    },
  }
}

export function usePendingReviewPageData({pathName, initialData}: {pathName: string; initialData?: PendingReviewIDs}) {
  const {queryFn, queryKey} = pendingReviewPayload(pathName)

  return useQuery<PendingReviewIDs | undefined>({
    queryKey,
    queryFn,
    initialData,
    staleTime: Infinity,
  })
}
